import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ObjectiveFlag } from '_components';
import { noteActions } from '_actions';
import { CheckBox } from './CheckBox';
import styles from './DBCheckBoxInputComment.module.css'

class DBCheckBoxInputComment extends React.Component {

    handleClick() {
        if (!this.props.disabled === true) {
            if (this.props.value) {
                this.props.clearField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field)
            } else {
                this.props.updateBitField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field, !this.props.value)
            }
            if (this.props.onClick) {
                this.props.onClick(!this.props.value);
            }
        }
    }

    constructor() {
        super();
        this.state = {
            value: '',
            txtValue: '',
            changingTimeout: 0,
            hasChanges: false,
        };
        this.handleValueChange = this.handleValueChange.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.saveValue = this.saveValue.bind(this);
    }

    componentDidMount() {
        this.setState((state) => {
            return {
                value: this.props.value ? this.props.value : '',
                txtValue: this.props.txtValue ? this.props.txtValue : ''
            };
        })
    }

    componentDidUpdate(prevProps) {
        if (this.props.noteId !== prevProps.noteId ||
            this.props.entity !== prevProps.entity ||
            this.props.entityKeyValue !== prevProps.entityKeyValue ||
            this.props.field !== prevProps.field ||
            this.props.value !== prevProps.value) {
            this.setState((state) => {
                return {
                    value: this.props.value ? this.props.value : '',
                    hasChanges: false,
                    txtValue: this.props.txtValue ? this.props.txtValue : ''
                };
            })
        }
    }

    handleValueChange(event) {
        if (this.state.changingTimeout) {
            clearTimeout(this.state.changingTimeout);
        }

        this.setState({
            txtValue: event.target.value,
            hasChanges: true,
            changingTimeout: setTimeout(() => this.saveValue(), 2000)
        });
    }

    saveValue() {
        if (this.state.hasChanges) {
            this.state.txtValue.trim() === '' ?
                this.props.clearField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field + 'TXT')
                :
                this.props.updateTextField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field + 'TXT', this.state.txtValue);
            this.setState({ hasChanges: false });

            if (this.props.onChange) {
                this.props.onChange(this.state.txtValue);
            }
        }
    }

    handleOnBlur() {
        this.saveValue();
        clearTimeout(this.state.changingTimeout);
    }

    handleDiagChangePattern(event) {
        if (event.target.value === '-1') {
            this.props.clearField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field + 'SKILL');
        }
        else if (event.target.value !== this.props.handelValue) {
            this.props.updateTextField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field + 'SKILL', event.target.value);
        }
    }

    render() {
        return (
            <>
                <div className={styles.row}>

                    {this.props.displayFlag ? (
                        <ObjectiveFlag
                            className={styles.flag}
                            flagged={this.props.flagged}
                            mopno={this.props.mopno}
                            flagText={this.props.label}
                        />
                    ) : (
                        <div className={styles.flag} />
                    )}
                    <CheckBox
                        title={this.props.title}
                        size={this.props.size}
                        className={styles.check_box}
                        checked={this.props.value}
                        label={this.props.label}
                        disabled={this.props.disabled}
                        onClick={() => this.handleClick()}
                    />



                    {this.props.value &&
                        <>
                            <select className={styles.drop_down} value={this.props.ddValue ? this.props.ddValue : '-1'} onChange={(event) => this.handleDiagChangePattern(event)} >
                                <option key={-1} value='-1'></option>
                                <option key={1} value='Not Observed'>Not Observed</option>
                                <option key={2} value='Emerging'>Emerging</option>
                                <option key={3} value='Skill Mastered'>Skill Mastered</option>
                                <option key={4} value='WNL'>WNL</option>
                            </select>
                        </>
                    }
                </div>
                <div>
                    {this.props.value &&
                        <>
                            <div className={styles.row}>
                                <span className={styles.flag}></span>
                                <textarea
                                    className={styles.textInput}
                                    type="text"
                                    title={this.props.title ? this.props.title : ''}
                                    onChange={this.handleValueChange}
                                    onBlur={this.handleOnBlur}
                                    disabled={this.props.disabled}
                                    rows={this.props.rows ? this.props.rows : 3}
                                    maxLength={this.props.maxLength ? this.props.maxLength : -1}
                                    placeholder={this.props.placeholder}
                                    value={this.state.txtValue} />
                            </div>
                        </>
                    }
                </div>
            </>
        );

    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
        updateTextField: bindActionCreators(noteActions.updateTextField, dispatch),
        clearField: bindActionCreators(noteActions.clearField, dispatch)
    };
}

function mapStateToProps(state, ownprops) {

    return {
        flagged: state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field] !== null ? state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field] : false,
        value: state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field] !== null ? state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field] : false,
        txtValue: state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field + 'TXT'] !== null ? state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field + 'TXT'] : false,
        disabled: ownprops.disabled !== undefined ? ownprops.disabled : false,
        ddValue: state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field + 'SKILL'] !== null ? state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field + 'SKILL'] : false,
        displayFlag: ownprops.displayFlag ?? true,
    };
}

const connectedInputComment = connect(mapStateToProps, mapDispatchToProps)(DBCheckBoxInputComment);
export { connectedInputComment as DBCheckBoxInputComment };